import script from "./DashboardDigestSettings.vue?vue&type=script&setup=true&lang=js"
export * from "./DashboardDigestSettings.vue?vue&type=script&setup=true&lang=js"

import "./DashboardDigestSettings.vue?vue&type=style&index=0&id=68234034&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-68234034"]])

export default __exports__